/**
 * Event types enum
 */
export const EventTypes = {

  // Employment events
  EMPLOYMENT_HIRE: 'employment.hire.initialized',
  EMPLOYMENT_REHIRE: 'employment.hire.rehire',
  EMPLOYMENT_START_DELAYED: 'employment.hire.start_delayed',
  EMPLOYMENT_NO_SHOW: 'employment.hire.no_show',
  EMPLOYMENT_WITHDRAWN: 'employment.hire.withdrawn',
  EMPLOYMENT_HIRE_FINALIZED: 'employment.hire.finalized',
  EMPLOYMENT_RESIGNATION_SUBMITTED: 'employment.resign.submitted',
  EMPLOYMENT_RESIGNATION_WITHDRAWN: 'employment.resign.withdrawn',
  EMPLOYMENT_TERMINATION_FINALIZED: 'employment.resign.finalized',
  // ADR-136 phase 6 (§15): scheduled (future-dated) contract replacement/renewal
  EMPLOYMENT_RENEWAL_SCHEDULED: 'employment.contract.renewal_scheduled',
  // …and its cancellation (B2 pattern): flips the pending renewal to Cancelled
  EMPLOYMENT_RENEWAL_CANCELLED: 'employment.contract.renewal_cancelled',
  // ADR-143 §7: a contract amendment — an operator-declared change of terms,
  // Pending until its effective date. Written ONLY through the dedicated
  // episode-addressed amendment routes (employmentApi.createContractAmendment)
  // — the backend's trigger endpoint rejects these codes by design (§9).
  EMPLOYMENT_CONTRACT_AMENDED: 'employment.contract.amended',
  // §7.1: its cancellation (B2 pattern) — Valid audit row, Pending intent
  // flips to Cancelled.
  EMPLOYMENT_CONTRACT_AMENDMENT_CANCELLED: 'employment.contract.amendment_cancelled',
  // ADR-176: a Pending amendment revised in place before it took effect —
  // Valid audit row with before/after; the amendment keeps its number.
  EMPLOYMENT_CONTRACT_AMENDMENT_REVISED: 'employment.contract.amendment_revised',
  // ADR-171 N1 / N5 (ADR-144 §7.4): the direct contract verbs, sent through
  // the trigger endpoint. replaced — one event for Replace Contract (the
  // backend replays the legs); cancelled — one event for Cancel Contract.
  EMPLOYMENT_CONTRACT_REPLACED: 'employment.contract.replaced',
  EMPLOYMENT_CONTRACT_CANCELLED: 'employment.contract.cancelled',
  // ADR-159: Void Contract (C5) and End Employment (the person verb)
  EMPLOYMENT_CONTRACT_VOIDED: 'employment.contract.voided',
  EMPLOYMENT_PERSON_EMPLOYMENT_ENDED: 'employment.person.employment_ended',
  // ADR-171 C4: Add Contract (a further contract beside the primary)
  EMPLOYMENT_CONTRACT_ADDED: 'employment.contract.added',
  // ADR-171 C1: an operator designated the primary (audit only, not a trigger verb)
  EMPLOYMENT_CONTRACT_PRIMARY_DESIGNATED: 'employment.contract.primary_designated',
};

// Backward compatibility - group employment events
export const EMPLOYMENT_EVENT_TYPES = {
  HIRE: EventTypes.EMPLOYMENT_HIRE,
  REHIRE: EventTypes.EMPLOYMENT_REHIRE,
  START_DELAYED: EventTypes.EMPLOYMENT_START_DELAYED,
  NO_SHOW: EventTypes.EMPLOYMENT_NO_SHOW,
  WITHDRAWN: EventTypes.EMPLOYMENT_WITHDRAWN,
  HIRE_FINALIZED: EventTypes.EMPLOYMENT_HIRE_FINALIZED,
  RESIGNATION_SUBMITTED: EventTypes.EMPLOYMENT_RESIGNATION_SUBMITTED,
  RESIGNATION_WITHDRAWN: EventTypes.EMPLOYMENT_RESIGNATION_WITHDRAWN,
  TERMINATION_FINALIZED: EventTypes.EMPLOYMENT_TERMINATION_FINALIZED,
  RENEWAL_SCHEDULED: EventTypes.EMPLOYMENT_RENEWAL_SCHEDULED,
  RENEWAL_CANCELLED: EventTypes.EMPLOYMENT_RENEWAL_CANCELLED,
  CONTRACT_REPLACED: EventTypes.EMPLOYMENT_CONTRACT_REPLACED,
  CONTRACT_CANCELLED: EventTypes.EMPLOYMENT_CONTRACT_CANCELLED,
  CONTRACT_VOIDED: EventTypes.EMPLOYMENT_CONTRACT_VOIDED,
  PERSON_EMPLOYMENT_ENDED: EventTypes.EMPLOYMENT_PERSON_EMPLOYMENT_ENDED,
  CONTRACT_ADDED: EventTypes.EMPLOYMENT_CONTRACT_ADDED,
  CONTRACT_AMENDED: EventTypes.EMPLOYMENT_CONTRACT_AMENDED,
  AMENDMENT_CANCELLED: EventTypes.EMPLOYMENT_CONTRACT_AMENDMENT_CANCELLED,
  AMENDMENT_REVISED: EventTypes.EMPLOYMENT_CONTRACT_AMENDMENT_REVISED,
};
